module.exports = __webpack_public_path__ + "files/d405d45777abcddfe4a6c16e33a833b7.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-italic-webfont.svg
 ** module id = 992
 ** module chunks = 0
 **/